import styled from 'styled-components'

export const ReadMoreTeaser = styled.div`
  background-color: #f6f6f6;
  padding: 20px 30px 38px;

  .headline {
    margin-bottom: 23px;
  }

  .read-more-content {
    background-color: white;
    padding: 23px 30px 34px;

    .fact-type {
      font-size: 16px;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.44;
      letter-spacing: normal;
      color: ${ (props) => props.theme.colors.grau2 };
      margin-bottom: 4px;
    }

    .fact-headline {
      margin-bottom: 17px;
    }
  }
`
